/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Widget_Today_No_PlanInputs */

const en_us2_native_release_widget_today_no_plan = /** @type {(inputs: Native_Release_Widget_Today_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No plan yet`)
};

const pt_br2_native_release_widget_today_no_plan = /** @type {(inputs: Native_Release_Widget_Today_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem plano ainda`)
};

const pt_pt2_native_release_widget_today_no_plan = /** @type {(inputs: Native_Release_Widget_Today_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem plano ainda`)
};

/** @type {(inputs: Native_Release_Widget_Today_No_PlanInputs) => LocalizedString} */
const es_419_native_release_widget_today_no_plan = en_us2_native_release_widget_today_no_plan;

/** @type {(inputs: Native_Release_Widget_Today_No_PlanInputs) => LocalizedString} */
const fr_fr2_native_release_widget_today_no_plan = en_us2_native_release_widget_today_no_plan;

/** @type {(inputs: Native_Release_Widget_Today_No_PlanInputs) => LocalizedString} */
const de_de2_native_release_widget_today_no_plan = en_us2_native_release_widget_today_no_plan;

/** @type {(inputs: Native_Release_Widget_Today_No_PlanInputs) => LocalizedString} */
const it_it2_native_release_widget_today_no_plan = en_us2_native_release_widget_today_no_plan;

/**
* | output |
* | --- |
* | "No plan yet" |
*
* @param {Native_Release_Widget_Today_No_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_today_no_plan = /** @type {((inputs?: Native_Release_Widget_Today_No_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Today_No_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_today_no_plan(inputs)
	if (locale === "es-419") return es_419_native_release_widget_today_no_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_today_no_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_today_no_plan(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_today_no_plan(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_today_no_plan(inputs)
	return en_us2_native_release_widget_today_no_plan(inputs)
});
export { native_release_widget_today_no_plan as "native-release.widget_today_no_plan" }